import { apiGet } from '../../../adapters/api-client/api';

/**
 * ADM-03-FR-06 — evidence requests addressed to the signed-in teacher.
 * Backend: reliability/infrastructure/controllers/teacher-evidence-request.controller.ts.
 * Metadata only: which session, which findings, by when. Never who asked.
 */
export interface TeacherEvidenceRequest {
  enrollmentId: string;
  courseId?: string;
  milestoneId: string;
  sequence?: number;
  /** The integrity findings' reason codes, e.g. `completed_with_missing_evidence`. */
  reasons: string[];
  requestedAt: string;
  dueAt?: string;
  /** Expired at `dueAt` exactly and after, on the server's clock. */
  deadlineState: 'OPEN' | 'EXPIRED' | null;
}

export function getTeacherEvidenceRequests(): Promise<{ requests: TeacherEvidenceRequest[] }> {
  return apiGet('/api/v1/teacher/evidence-requests');
}
